import { Component, Input, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-guidevideos',
    templateUrl: './guidevideos.component.html',
    standalone: false
})
export class GuidevideosComponent {
  @Input() modules;
  public url: string;
  constructor(
    public activeModel: NgbActiveModal,
    public domSanitizer: DomSanitizer
  ) {}
  ngOnInit() { 
    if (this.modules?.videourl) {
      const url = this.domSanitizer.sanitize(
        SecurityContext.URL,
        this.modules?.videourl.toString()
      );
      this.url = this.domSanitizer.bypassSecurityTrustResourceUrl(
        url
      ) as string;
    }
  }
}
